import React, { Component } from 'react';
import EnviarMultiplesArchivos from "../general/EnviarMultiplesArchivos";
import AlertasSimple from '../general/AlertasSimple';
import {BtnCargar, BtnEliminar} from "../general/BotonesAccion";
import CustomDropzone from "../general/CustomDropzone";
import { Paper, Grid, List, Collapse, Chip } from '@material-ui/core'
import AttachFileIcon from '@material-ui/icons/AttachFile';


export default class SolicitudesAgregarAdjuntos extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mostrarOpcionales: false,
    }
  }

  render() {
    let { submit, agregarArchivos, eliminarArchivo, cambiarEstado, requisitos, archivos2, actualizarMensaje } = this.props.props_c;
    let { mostrarOpcionales } = this.state;

    let obligatorio = []
    requisitos.map((info) => {
      if (info.valora === '1') {
        obligatorio.push({ item: info.nombre })
      }
    })

    const trasnformarDataAdj = (data) => {
      let r = [];
      data.map((info) => r.push({ nombre: info.nombre, codigo: info.id, archivo: info.archivo, formatos: info.valorg }))
      return r;
    }

    const acciones = (data, callback) => {
      const onClickCargar = (data) => callback(data);
      let cargar = <BtnCargar callback={() => onClickCargar(data)} color='#00bfa5' texto='Gestionar' />
      return <div>{cargar}</div>;
    }

    return (
      <React.Fragment>
        <Grid container spacing={3}>
          <AlertasSimple
            tipo='info'
            titulo={'Estimado, tener en cuenta que estos documentos son obligatorios: '}
            lista={obligatorio}
            margin='0px'
          />
          <Grid item xs={12}>
            <Paper elevation={0} square>
              <List component="nav" arial-label="main">
                <EnviarMultiplesArchivos
                  acciones={acciones}
                  enModal={false}
                  enviarArchivos={(archivos) => submit(archivos)}
                  limite={2}
                  mostrarMensaje={false}
                  enLista={true}
                  lista={trasnformarDataAdj(requisitos)}
                  formatos={true}
                />
              </List>
            </Paper>
          </Grid>
          <AlertasSimple
            tipo='success'
            titulo={'¡Para cargar otros documentos que usted considere necesario clic acá!'}
            margin='0px'
            callback={() => this.setState({ mostrarOpcionales: !mostrarOpcionales })}
          />
          <Grid item xs={12}>
            <Collapse in={mostrarOpcionales}>
              <CustomDropzone
                archivos={archivos2}
                addFunction={agregarArchivos}
                deleteFunction={eliminarArchivo}
                actualizarMensaje={actualizarMensaje}
              />
            </Collapse>
            {archivos2 && archivos2.length > 0 && (
              <div style={{ marginTop: 8 }}>
                {archivos2.map((file, i) => (
                  <Chip
                    key={i}
                    icon={<AttachFileIcon />}
                    label={file.name || `Archivo ${i + 1}`}
                    onDelete={() => eliminarArchivo(i)}
                    style={{ margin: '4px 4px 4px 0' }}
                    color="primary"
                    variant="outlined"
                  />
                ))}
              </div>
            )}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}
